var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "explain-block block" }, [
    _c("div", { staticClass: "block-title" }, [
      _c("div", { staticClass: "dot" }),
      _vm._v(" " + _vm._s(_vm.$t("incubator.explain.title")) + " "),
    ]),
    _c("div", { staticClass: "video" }, [
      _c("iframe", {
        staticClass: "video-frame",
        attrs: {
          src: _vm.getVideo(_vm.content.video),
          title: "YouTube video player",
          frameborder: "0",
          allow:
            "accelerometer; autoplay; clipboard-write;\n        encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
        },
      }),
    ]),
    _c("div", { staticClass: "content sub-block" }, [
      _c(
        "div",
        { staticClass: "block-content" },
        [_c("content-renderer", { attrs: { content: _vm.content.explain } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }